<template>
  <v-dialog
    v-model="visible"
    :width="modalWidth"
    :height="modalHeight"
    persistent
    :retain-focus="false"
  >
    <v-card
      style="position: relative; height: 100%; max-height: calc(100vh - 48px)"
    >
      <div class="d-flex justify-space-between align-center">
        <h1>
          Ste si istý, že chcete
          {{ mastertask.is_finished ? 'znovu otvoriť' : 'dokončiť' }}
          <b>{{ mastertask?.name }}</b
          >?
        </h1>
        <div class="d-flex align-start">
          <a-reset-size-button @reset="resetModalSize" />
          <a-close-button @close="() => (visible = false)" />
        </div>
      </div>
      <v-card-actions
        class="mt-10 d-flex justify-start align-center mobile-view"
      >
        <v-btn class="button primary half" variant="flat" @click="complete()"
          >ÁNO</v-btn
        >
        <v-btn class="button primary half outline" @click.stop="visible = false"
          >ZRUŠIŤ</v-btn
        >
      </v-card-actions>
      <a-resize-handle
        :current-width="modalWidthPx"
        :current-height="modalHeightPx"
        @resize="handleModalResize"
        @resize-end="handleResizeEnd"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import modalMixin from '@/plugins/tm@modal/_mixins/modal.mixin';
import AResizeHandle from '@/plugins/tm@modal/_components/a-resize-handle.vue';
import AResetSizeButton from '@/plugins/tm@modal/_components/a-reset-size-button.vue';
import ACloseButton from '@/plugins/tm@modal/_components/a-close-button.vue';

export default {
  components: {
    AResizeHandle,
    AResetSizeButton,
    ACloseButton,
  },
  mixins: [modalMixin],
  emits: ['close', 'master-task-edited'],

  data() {
    return {
      visible: false,
      mastertask: null,
      modalName: 'z-complete-master-task-modal',
      modalSize: 'small',
    };
  },

  methods: {
    async showModal({ mastertask }) {
      this.mastertask = mastertask;
      this.visible = true;
    },

    async complete() {
      try {
        const tempMastertask = {
          ...this.mastertask,
          is_finished: this.mastertask.is_finished ? 0 : 1,
        };
        const { mastertask } = await this.$axios.put_auth(
          `v1/mastertasks/${tempMastertask.id}`,
          tempMastertask,
        );

        this.visible = false;
        this.$emit('master-task-edited', mastertask);
        this.$events.emit('close-both-modals');
      } catch (error) {
        this.$toast.error(this.$parseError(error));
      }
    },
  },
};
</script>
